<div class="tenants">
    <div class="tenants-header">
        <tools-button routerLink="/admin/tenants/new">
            Create New Tenant
        </tools-button>
    </div>
    @if (showEmptyState()) {
        <section class="empty" aria-label="Empty state">
            <h3>No Tenants Yet</h3>
            <p>
                Create a tenant to make a show or channel available in the tool.
            </p>
        </section>
    } @else {
        <tools-table [dataSource]="dataSource" [format]="tableFormat">
            <ng-template #custom let-row="data">
                @if (!row.showChildTemplate) {
                    <img
                        class="tenants-image"
                        [src]="
                            row.data.tenantLogoUrl ||
                            'assets/tenant-no-image.png'
                        "
                        [alt]="row.data.name"
                    />
                }
                @if (row.showChildTemplate === "theme-name") {
                    {{ themeNameMap().get(row.data.themeId) }}
                }
                @if (row.showChildTemplate === "edit-action") {
                    <a
                        class="tenants-edit-action"
                        [routerLink]="['/admin/tenants', row.data.id, 'edit']"
                    >
                        <span class="icon-edit"></span>
                        Edit
                    </a>
                }
            </ng-template>
        </tools-table>
        <tools-paginator [variant]="paginatorVariant"></tools-paginator>
    }
</div>
